import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { statusDisplayNameToValueMap } from 'src/app/shared/common/job-filter/job-filter-streams.service';
import { SurveyJobStatus } from 'src/app/shared/survey-data-services/survey-job';

@Component({
    selector: 'edit-job-status',
    templateUrl: './edit-job-status.component.html'
})
export class EditJobStatusComponent implements OnInit {
    @Input() jobStatus: SurveyJobStatus;

    @Output() jobStatusChange = new EventEmitter<SurveyJobStatus>();

    options = Object.keys(statusDisplayNameToValueMap);
    selectedDisplayName: string = '';

    ngOnInit(): void {
        if (this.jobStatus) {
            this.selectedDisplayName =
                Object.keys(statusDisplayNameToValueMap).find(
                    key => statusDisplayNameToValueMap[key] === this.jobStatus
                ) || '';
        }
    }

    onStatusChange(newStatus: string): void {
        this.selectedDisplayName = newStatus;
        this.jobStatusChange.emit(statusDisplayNameToValueMap[this.selectedDisplayName]);
    }
}
